import { useState, useEffect } from 'react';
import { useContent } from '../hooks/useContent';
import './Timeline.css';

export default function Timeline() {
    const { TIMELINE, ui } = useContent();
    const tUi = ui.timeline;
    const common = ui.common;
    const [cur, setCur] = useState(0);
    const [animDir, setAnimDir] = useState(1);

    const goTo = (idx) => {
        if (idx === cur) return;
        setAnimDir(idx > cur ? 1 : -1);
        setCur(idx);
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setCur(c => {
                const next = (c + 1) % TIMELINE.length;
                setAnimDir(next === 0 ? -1 : 1);
                return next;
            });
        }, 8000);
        return () => clearInterval(interval);
    }, []);

    const t = TIMELINE[cur];
    const progress = ((cur) / (TIMELINE.length - 1)) * 100;

    return (
        <section id="story" style={{ background: 'var(--offwhite)' }}>
            <div className="section">
                <div style={{ textAlign: 'center', marginBottom: 52 }}>
                    <div className="section-label" style={{ justifyContent: 'center' }}>{tUi.label}</div>
                    <h2 className="section-title" style={{ textAlign: 'center' }}>
                        {tUi.title} <em>{tUi.titleEm}</em>
                    </h2>
                </div>

                {/* HORIZONTAL TIMELINE */}
                <div className="tl-wrap">
                    <button className="tl-nav prev" onClick={() => cur > 0 && goTo(cur - 1)} disabled={cur === 0} aria-label={common.back}>
                        <ChevL />
                    </button>
                    <button className="tl-nav next" onClick={() => cur < TIMELINE.length - 1 && goTo(cur + 1)} disabled={cur === TIMELINE.length - 1} aria-label={common.forward}>
                        <ChevR />
                    </button>

                    <div className="tl-line-wrap">
                        <div className="tl-line" />
                        <div className="tl-fill" style={{ width: `${progress}%` }} />
                        <div className="tl-dots">
                            {TIMELINE.map((item, i) => (
                                <div
                                    key={i}
                                    className={`tl-dot-wrap ${i === cur ? 'active' : ''} ${i < cur ? 'passed' : ''}`}
                                    style={{ left: `${(i / (TIMELINE.length - 1)) * 100}%` }}
                                    onClick={() => goTo(i)}
                                >
                                    <div className="tl-year-label">{item.year}</div>
                                    <div className="tl-dot" />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* EVENT CARD */}
                <div className="tl-card" key={cur} style={{ '--anim-dir': animDir }}>
                    <div className="tl-card-year">{t.year}</div>
                    <div className="tl-card-body">
                        <span className="tl-card-tag">{t.tag}</span>
                        <h3 className="tl-card-title">{t.title}</h3>
                        <p className="tl-card-desc">{t.desc}</p>
                    </div>
                </div>
            </div>
        </section>
    );
}

function ChevL() { return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M15 18l-6-6 6-6" /></svg>; }
function ChevR() { return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M9 6l6 6-6 6" /></svg>; }